import BkBridge from './bkbridge';

export default BkBridge;